module.exports = __webpack_public_path__ + "static/media/record-nav-right-inactive.9402aaa4.svg";